import React, { useEffect } from "react";
import { Modal, Form, Input, Col, Row, message, Upload, Image } from "antd";
import { API_METHODS } from "../../constants";
import useApi from "../../hooks/useApi";
import { InboxOutlined } from "@ant-design/icons";

function AddSocialLink(props) {
  const [form] = Form.useForm();
  const { visible, close, selectedRecord } = props;
  const [response, request] = useApi(
    "/admin/social-links",
    null,
    API_METHODS.POST,
    true // for multipart data
  );
  const [editResponse, editRequest] = useApi(
    `/admin/social-links/${selectedRecord && selectedRecord.id}`,
    null,
    API_METHODS.PUT,
    true // for multipart data
  );

  useEffect(() => {
    if (response.data) {
      close(true);
      message.success("Link added successfully.");
    } else if (response.error) {
      close(true);
    }
  }, [response]);

  useEffect(() => {
    if (editResponse.data) {
      close(true);
      message.success("Link updated successfully.");
    } else if (editResponse.error) {
      close(true);
    }
  }, [editResponse]);

  useEffect(() => {
    if (selectedRecord) {
      form.setFieldsValue(selectedRecord);
    }
  }, [selectedRecord]);

  const handleOk = () => {
    form
      .validateFields()
      .then((values) => {
        const formData = new FormData();
        for (const name in values) {
          if (name === "image") {
            if (values["image"] !== undefined) {
              formData.append(
                "image",
                values["image"].file.originFileObj,
                values["image"].file.name
              );
            }
          } else {
            formData.append(name, values[name]);
          }
        }
        if (selectedRecord) {
          editRequest(formData);
        } else {
          request(formData, API_METHODS.POST);
        }
      })
      .catch((e) => {});
  };

  const handleCancel = () => {
    close();
  };

  const uploadProps = {
    beforeUpload: (file) => {
      const isImage = file.type === "image/png" || file.type === "image/jpeg";
      if (!isImage) {
        message.error(`${file.name} error. Only PNG and JPEG files supported`);
        return Upload.LIST_IGNORE;
      }
      return isImage;
    },
  };

  const dummyRequest = ({ file, onSuccess }) => {
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  };

  return (
    <Modal
      title={selectedRecord ? "Update Link" : "Add Link"}
      open={visible}
      onOk={handleOk}
      onCancel={handleCancel}
      width={1000}
      okText="Save"
    >
      <Form layout="vertical" form={form}>
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item
              name="text"
              label="Text"
              rules={[
                { required: true, message: "text is required." },
                {
                  max: 50,
                  message: "text should be maximum of 50 characters.",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="link"
              label="Link"
              rules={[
                { required: true, message: "link is required." },
                {
                  max: 500,
                  message: "link should be maximum of 500 characters.",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item
              name="image"
              rules={[{ required: true, message: "Logo is required." }]}
            >
              <Upload.Dragger
                customRequest={dummyRequest}
                {...uploadProps}
                maxCount={1}
              >
                <p className="ant-upload-drag-icon">
                  <InboxOutlined />
                </p>
                <p className="ant-upload-text">
                  Click or drag file to this area to upload
                </p>
              </Upload.Dragger>
            </Form.Item>
          </Col>
        </Row>
        <Row>
          {selectedRecord && <Image src={selectedRecord.logo} width={100} />}
        </Row>
      </Form>
    </Modal>
  );
}

export default AddSocialLink;
